<h4 class="mb-4 text-1xl font-extrabold md:text-3xl lg:text-2xl">
  There is <span class="text-transparent bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">NO ACCESS </span>to
  this route. <br />

  Please logout and try to login with
  <span
    class="text-transparent underline decoration-4 bg-clip-text bg-gradient-to-r to-purple-500 from-red-500 decoration-red-800"
    >a profile that HAS ACCESS.</span
  >
</h4>
